<template>
  <svg
    @click="$emit('click',$event)"
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g opacity="1">
      <path
        d="M14.5862 0.0996094H5.41382C2.42859 0.0996094 0 2.5282 0 5.51343V14.6859C0 17.671 2.42859 20.0996 5.41382 20.0996H14.5863C17.5714 20.0996 20 17.671 20 14.6859V5.51343C20 2.5282 17.5714 0.0996094 14.5862 0.0996094V0.0996094ZM10 15.5682C6.98456 15.5682 4.5314 13.1151 4.5314 10.0996C4.5314 7.08417 6.98456 4.63101 10 4.63101C13.0154 4.63101 15.4686 7.08417 15.4686 10.0996C15.4686 13.1151 13.0154 15.5682 10 15.5682ZM15.5994 5.92068C14.7083 5.92068 13.9835 5.19589 13.9835 4.30478C13.9835 3.41367 14.7083 2.68872 15.5994 2.68872C16.4905 2.68872 17.2154 3.41367 17.2154 4.30478C17.2154 5.19589 16.4905 5.92068 15.5994 5.92068Z"
        fill="white"
      />
      <path
        d="M9.99924 5.80353C7.63046 5.80353 5.70312 7.73071 5.70312 10.0996C5.70312 12.4684 7.63046 14.3958 9.99924 14.3958C12.3682 14.3958 14.2953 12.4684 14.2953 10.0996C14.2953 7.73071 12.3682 5.80353 9.99924 5.80353Z"
        fill="white"
      />
      <path
        d="M15.5997 3.86139C15.3552 3.86139 15.1562 4.06036 15.1562 4.30481C15.1562 4.54926 15.3552 4.74823 15.5997 4.74823C15.8443 4.74823 16.0432 4.54941 16.0432 4.30481C16.0432 4.06021 15.8443 3.86139 15.5997 3.86139Z"
        fill="#C5C5C5"
      />
    </g>
  </svg>
</template>
<script>
export default {};
</script>
<style lang="less" scoped>
svg {
    cursor:pointer;
}
</style>